<template>
	<div class="finance-process">
		<div class="finance-steps">
			<div v-for="(step, index) in steps" :key="step.title" class="finance-step">
				<div class="step-rail">
					<div class="step-icon" aria-hidden="true">
						<nio-icon v-if="step.icon" :name="step.icon" :size="24" />
					</div>
					<div v-if="index < steps.length - 1" class="step-line" />
				</div>
				<div class="step-content">
					<div class="step-title">{{ step.title }}</div>
					<div class="step-description">{{ step.description }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FinanceProcess',
	data() {
		return {
			steps: [
				{ icon: 'icon_pay_deposit_s', title: '支付定金', description: '选择并订购您的心仪爱车' },
				{
					icon: 'icon_financialdetail_m',
					title: '金融申请',
					description: '"金融计算器"可进行试算，联系牛小二下单并准备金融申请材料'
				},
				{ icon: 'icon_quality_s', title: '金融审核', description: '由相应金融机构出具审核结果' },
				{
					icon: 'icon_handshake_s',
					title: '合同签署',
					description: '金融机构会指引您签署合同，支付首付款'
				},
				{ icon: 'icon_drive_enjoy_s', title: '放款提车', description: '金融机构放款完成，喜提爱车' }
			]
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';

.finance-process {
	padding: 0 20px;
}

.finance-step {
	display: flex;
	min-height: 83px;
	&:last-child {
		min-height: 50px;
	}
}

.step-rail {
	position: relative;
	margin-right: 10px;
}

.step-icon {
	position: relative;
	z-index: 1;
	display: flex;
	width: 50px;
	height: 50px;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: var(--bg_secondary);

	img {
		width: 24px;
		height: 24px;
		object-fit: contain;
	}
}

.step-line {
	position: absolute;
	top: 58px;
	left: 24px;
	width: 1px;
	height: 26px;
	background: var(--border_divider_primary);
}

.step-content {
	padding: 5px 0 28px;
}

.step-title {
	@include subtitle_3(1.5, 500, false);
}

.step-description {
	@include body_3(1.5, 400, false);
	color: var(--text_tertiary);
}
</style>
